<script setup lang="ts">
import { TableEntityChangelog, ModalChangelogDetail } from '@widgets/changelog'

import { useKidChangelog } from '../model/kid-changelog.hook'

defineOptions({
  name: 'KidChangelogPage',
})

useKidChangelog()
</script>

<template>
  <TableEntityChangelog />
  <ModalChangelogDetail />
</template>
